import React from 'react';
import { apptAddressGroupLabels } from 'utils';

export const apptAddressGroupBy = (option) => apptAddressGroupLabels[option?.type] || '';

export const renderApptAddressGroup = (params) => (
    <li key={params.key}>
        {params.group && <p className="appt-address-group-title">{params.group}</p>}
        <ul style={{ padding: 0 }}>{params.children}</ul>
    </li>
);

export const ApptAddressOption = ({ option }) => (
    <div className="appt-address-option">
        {option?.label && <p className="appt-address-option-label">{option.label}</p>}
        <p className="appt-address-option-address">{option?.name}</p>
    </div>
);
